import EventName from '@/Enums/EventName.enum';

type AsyncAction = () => Promise<void>;

const isAbortError = (err: any) => {
  return err?.name === 'AbortError' || err?.code === 'ERR_CANCELED';
};

export async function runLoadingActionsForPrint({
  reset = () => null,
  actions,
  onError = (e: unknown) => console.error(e),
}: {
  reset?: () => void;
  actions: AsyncAction | AsyncAction[];
  onError?: (e: unknown) => void;
}): Promise<void> {
  reset();

  const runOne = async (fn: AsyncAction) => {
    try {
      await fn();
    } catch (error) {
      if (isAbortError(error)) {
        throw error;
      }
      onError(error);
    }
  };

  if (Array.isArray(actions)) {
    for (const a of actions) {
      await runOne(a);
    }
  } else {
    await runOne(actions);
  }
}

export const autosizeCb = async () => {
  await new Promise<void>(resolve => requestAnimationFrame(() => requestAnimationFrame(() => resolve())));
  window.dispatchEvent(new Event(EventName.PrintAutosize));
  await new Promise<void>(resolve => requestAnimationFrame(() => resolve()));
};
